// extracted by mini-css-extract-plugin
export default {"sectionImageTeam":"sectionImage_sectionImageTeam__HL1O5","teamText":"sectionImage_teamText__EbR6b"};